import styled from "styled-components"

const Container = styled.div.attrs(() => ({
  className: "container pb-5 vh-200",
}))``

export default Container
